import React, {useEffect, useState} from 'react';

import './styles.scss';
import {connect} from 'react-redux';
import {
  addToGlobalStyles,
  addToWizard,
  setGlobalStyles,
  setStrings,
  setWizard,
  setStringsDefault,
  setBuDefaultFunctionalities,
  setIsLanguageSelected,
  setLanguage,
  setLanguageOptions,
} from '../../store/actions';
import {compose} from 'redux';
import RegisterHeader from '../../components/headers/register-header';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import * as fonts from '../../util/fonts';
import colors, {pageBackgrounds} from '../../util/colors';
import {
  getDataFromCMD,
  uriGetFunctionalities,
  uriStartRegister,
} from '../../api/endpoints';
import {has18Years, updateStringFeatureWithLabels} from '../../util/utility';
import AppSpinner from '../../components/app-spinner';
import {withRouter} from 'react-router';
import {get, post, postWithCustomHeaders} from '../../api/api';
import {
  AppForm,
  AppFormRadioField,
  AppFormSubmitButton,
} from '../../components/forms';
import * as Yup from 'yup';
import BeforeContinueCMD from './before-continue/BeforeContinueCMD';
import CommunicationsCMD from './communications-cmd/CommunicationsCMD';
import AccountDataCMD from './account-data-cmd/AccountDataCMD';
import {ITenant} from '../../App';

export interface RegisterPageCMDProps {
  wizard: any;
  globalStyles: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  setGlobalStyles(value: any): void;
  setStrings(value: any): void;
  setStringsDefault(value: any): void;
  setBuDefaultFunctionalities(value: any): void;
  labels: typeof strings.pt.registoCMD;
  labelsRegister: any;
  labelsMessages: typeof strings.pt.messages;
  history?: any;
  reduxStrings: any;
  user: any;
  isLanguageSelected: boolean;
  language: string;
  setLanguage(value: any): void;
  setIsLanguageSelected(value: any): void;
  setLanguageOptions(value: any): void;
  languageOptions: any;
  tenant: ITenant;
}

const RegisterPageCMD = ({
  wizard,
  globalStyles,
  setWizard,
  addToWizard,
  addToGlobalStyles,
  setGlobalStyles,
  setStrings,
  setStringsDefault,
  setBuDefaultFunctionalities,
  labels,
  labelsMessages,
  labelsRegister,
  history,
  reduxStrings,
  user,
  isLanguageSelected,
  language,
  setLanguage,
  setIsLanguageSelected,
  setLanguageOptions,
  languageOptions,
  tenant,
}: RegisterPageCMDProps) => {
  const getUrlLanguage = () => {
    return new URLSearchParams(window.location.search).get('language');
  };

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingAttributes, setIsLoadingAttributes] = useState(true);
  const [isMultiLanguage, setIsMultiLanguage] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    getUrlLanguage() || language || '',
  );
  const [showCommunications, setShowCommunications] = useState(false);
  const [showAccountData, setShowAccountData] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isStartingRegister, setIsStartingRegister] = useState(false);
  const [isStartRegisterCompleted, setIsStartRegisterCompleted] =
    useState(false);
  const [userDob, setUserDob] = useState('');
  const [userNif, setUserNif] = useState('');
  const [userName, setUserName] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [userSurname, setUserSurname] = useState('');

  const featureName = 'RedirectPageCMD';

  const verifyCancelledRegisterCMD = () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const error = params.get('error') || '';
    if (error) {
      sendMessageToAppInScript('-1', '-1', '-1', '-1', '-1');
      history.push('/');
    }
  };

  useEffect(() => {
    setWizard({});
    verifyCancelledRegisterCMD();
    const urlLang = getUrlLanguage();
    const targetLanguage =
      urlLang || language || labelsMessages?.default_language;

    if (urlLang) {
      setCurrentLanguage(urlLang);
      setLanguage(urlLang);
    } else if (targetLanguage) {
      setCurrentLanguage(targetLanguage);
      setLanguage(targetLanguage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  useEffect(() => {
    if (tenant) {
      getLanguage();
      requestAuthentication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant?.alias]);

  // useEffect(() => {
  //   if (userDob && userNif && userName && userPhone) {
  //     sendMessageToAppInScript(userNif, userDob, userName, userPhone);
  //   }
  // }, [userNif, userDob, userName, userPhone]);

  const sendMessageToAppInScript = (
    userNif: any,
    userDob: any,
    name: any,
    surname: any,
    phone: any,
  ) => {
    // Check if the script function exists before calling it
    if ((window as any)?.sendMessageToApp) {
      (window as any).sendMessageToApp(userNif, userDob, name, surname, phone);
    }
  };

  const requestAuthentication = async () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const localStorageUser = JSON.parse(
      localStorage?.getItem('user') as string,
    );
    const accessToken =
      params.get('access_token') || localStorageUser?.access_token;
    const birthdate = 'http://interop.gov.pt/MDC/Cidadao/DataNascimento';
    const nif = 'http://interop.gov.pt/MDC/Cidadao/NIF';
    const userName = 'http://interop.gov.pt/MDC/Cidadao/NomeProprio';
    const surname = 'http://interop.gov.pt/MDC/Cidadao/NomeApelido';
    const phone = 'http://interop.gov.pt/MDC/Cidadao/NumeroTelemovel';

    const attributesName = [birthdate, nif, userName, surname, phone];
    console.log('attributesName', attributesName);

    const body = JSON.stringify({
      token: accessToken,
      attributesName,
    });
    try {
      const response: any = await post(
        getDataFromCMD(),
        body,
        false,
        featureName,
      );
      let nifValue = '';
      let dobValue = '';
      let nameValue = '';
      let surnameValue = '';
      let phoneNumberValue = '';
      console.log('response.data1', response?.data);

      if (response) {
        console.log('response.data2', response?.data);

        response?.data?.items?.forEach((item: any) => {
          if (item.name === birthdate) {
            setUserDob(item.value);
            dobValue = item.value;
          } else if (item.name === nif) {
            setUserNif(item.value);
            nifValue = item.value;
          } else if (item.name === userName) {
            setUserName(item.value);
            nameValue = item.value;
          } else if (item.name === phone) {
            setUserPhone(item.value);
            phoneNumberValue = item.value;
          } else if (item.name === surname) {
            setUserSurname(item.value);
            surnameValue = item.value;
          }
        });
        if (dobValue) {
          checkDob(dobValue);
        }
      }
      console.log('response.data3', response?.data);
      sendMessageToAppInScript(
        nifValue,
        dobValue,
        nameValue,
        surnameValue,
        phoneNumberValue,
      );
    } catch (error: any) {
      console.error('There was an error fetching data from CMD:', error);
    } finally {
      setIsLoadingAttributes(false);
    }
  };

  const checkDob = async (dob?: string) => {
    const dobValue = dob || userDob;
    if (!dobValue) return;

    let dateObject: Date;
    if (dobValue.includes('-')) {
      const parts = dobValue.split('-').map(Number);
      if (parts[0] > 1000) {
        dateObject = new Date(parts[0], parts[1] - 1, parts[2]);
      } else {
        dateObject = new Date(parts[2], parts[1] - 1, parts[0]);
      }
    } else if (dobValue.includes('/')) {
      const parts = dobValue.split('/').map(Number);
      if (parts[0] > 1000) {
        dateObject = new Date(parts[0], parts[1] - 1, parts[2]);
      } else {
        dateObject = new Date(parts[2], parts[1] - 1, parts[0]);
      }
    } else {
      dateObject = new Date(dobValue);
    }

    if (!has18Years(dateObject)) {
      history.push('/utilizador-menor');
    }
  };

  const getLanguage = async () => {
    addToGlobalStyles({
      background: pageBackgrounds.registerPage,
    });
    getLanguageOptions();
    const urlLang = getUrlLanguage();
    const langToUse =
      urlLang || language || tenant?.mainLanguageAlias || 'PT';
    getLabels(langToUse);
  };

  const getLanguageOptions = async () => {
    const languageOptions = tenant?.languages?.map((lng: any) => lng.alias);
    setLanguageOptions(languageOptions);
  };

  const getLabels = async (language: string, checkUnderage = false) => {
    const newDefaultFunctionalities = await get(
      uriGetFunctionalities('ADV'),
      false,
      0,
      featureName,
    ).then((response: any) => ({
      funcionalidade: response?.data?.items || response,
    }));

    let stringsToState = {...strings, ...reduxStrings};

    if (!!newDefaultFunctionalities) {
      newDefaultFunctionalities.funcionalidade.length > 0 &&
        newDefaultFunctionalities.funcionalidade.find(
          (funct: any) =>
            funct?.featureTemplateAlias ===
              functionalitiesAliasMap.multiLanguage && funct?.isVisible,
        ) &&
        setIsMultiLanguage(true);
      setBuDefaultFunctionalities(newDefaultFunctionalities);
      stringsToState = updateStringFeatureWithLabels(
        stringsToState,
        newDefaultFunctionalities.funcionalidade,
      );
      setStringsDefault(stringsToState);
      setStrings(stringsToState);
    } else {
      setStringsDefault(strings);
      setStrings(strings);
    }
    setIsLoading(false);
    checkUnderage && checkDob();
  };

  const renderLanguageSelector = () => {
    const defaultSelected =
      getUrlLanguage() ||
      language ||
      currentLanguage ||
      labelsMessages?.default_language;

    return (
      <AppForm
        validationSchema={validationSchema}
        initialValues={{
          selectedLanguage: defaultSelected,
        }}
        onSubmit={(values) => {
          setLanguage(values.selectedLanguage);
          history.push({
            pathname: window.location.pathname,
            search: `?language=${values.selectedLanguage}`,
            hash: window.location.hash,
          });
          setIsLoading(true);
          setCurrentLanguage(values.selectedLanguage);
          getLabels(values.selectedLanguage, true);

          setIsLanguageSelected(true);
        }}
        className="register-language-selector-form">
        <AppFormRadioField
          className="register-language-selector-radio-select"
          name="selectedLanguage"
          options={renderLanguageOptions(languageOptions)}
        />
        <div>
          <p
            className="register-language-selector-info"
            style={{
              ...fonts.M,
              color: colors.black,
            }}>
            {labels?.registoCMD_multi_language_info}
          </p>
          <AppFormSubmitButton
            title={labels?.registoCMD_contactActivation_buttonText}
            type="submit"
          />
        </div>
      </AppForm>
    );
  };

  const renderLanguageOptions = (languageOptions: any) => {
    const result = languageOptions ? [...languageOptions] : [];

    const ptLangIndex = result.findIndex(
      (el: any) => el === labelsMessages?.default_language,
    );
    if (ptLangIndex !== -1) {
      const ptLang = result.splice(ptLangIndex, 1);
      result.unshift(ptLang[0]);
    }

    return result.map((option: any) => ({
      label: labelsRegister?.[option],
      value: option,
    }));
  };

  const validationSchema = Yup.object().shape({});

  const handleStartRegister = async (
    nif = userNif,
    dob = userDob,
    name = userName,
    surname = userSurname,
    selectedLang?: string,
  ) => {
    if (!nif || !dob) return;
    if (dob) {
      checkDob(dob);
    }
    const fullName = [name, surname].filter(Boolean).join(' ').trim();
    const selectedLanguage =
      selectedLang || language || tenant?.mainLanguageAlias || 'PT';

    setIsStartingRegister(true);

    const body = {
      nif: nif,
      dob: dob,
      fullName: fullName,
      language: selectedLanguage,
    };

    const customHeaders = {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': selectedLanguage,
        advSource: 'WebPortal',
        advBu:
          wizard?.dataValidation?.currentUser?.contacts?.buId ||
          tenant?.buDefaultAlias,
        advMemId: wizard?.insuranceValidation?.memId || '',
        feature: featureName,
        X_MYADV_API_KEY: process.env.REACT_APP_DEFAULT_TENANT_ALIAS,
      },
    };

    try {
      const registerRes: any = await postWithCustomHeaders(
        uriStartRegister(),
        JSON.stringify(body),
        customHeaders,
      );

      const isRegistered = !!(
        registerRes?.isRegisteredInWso2 ||
        registerRes?.data?.isRegisteredInWso2
      );

      if (isRegistered) {
        history.push('/utilizador-existente');
        return;
      }

      const sessionId =
        registerRes?.sessionId || registerRes?.data?.sessionId;

      if (!sessionId) {
        throw new Error('SessionId não recebido do servidor.');
      }

      addToWizard({
        insuranceValidation: {
          ...wizard?.insuranceValidation,
          nif: nif,
          dateOfBirth: dob,
          name: fullName,
          fullName: fullName,
          userName: name,
          surname: surname,
        },
        dataValidation: {
          ...wizard?.dataValidation,
          state: 'CLIENT',
          currentUser: {
            ...wizard?.dataValidation?.currentUser,
            sessionId: sessionId,
            fullName: fullName,
            nif: nif,
            dob: dob,
          },
        },
        sessionId: sessionId,
        activateRegistration: {
          ...wizard?.activateRegistration,
          guid: sessionId,
        },
      });

      setIsStartRegisterCompleted(true);
    } catch (error: any) {
      const status = error?.status ?? error?.response?.status;
      if (status === 409) {
        history.push('/utilizador-existente');
        return;
      }
      history.push('/registo-bloqueado');
    } finally {
      setIsStartingRegister(false);
    }
  };

  useEffect(() => {
    if (
      !isLoading &&
      !isLoadingAttributes &&
      (!isMultiLanguage || isLanguageSelected) &&
      !isStartRegisterCompleted &&
      !isStartingRegister &&
      userNif &&
      userDob
    ) {
      handleStartRegister(userNif, userDob, userName, userSurname, language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isLoading,
    isLoadingAttributes,
    isMultiLanguage,
    isLanguageSelected,
    isStartRegisterCompleted,
    isStartingRegister,
    userNif,
    userDob,
    userName,
    userSurname,
    language,
  ]);

  const beforeContinueOnSubmit = (values: any) => {
    addToWizard({
      insuranceValidation: {
        ...wizard?.insuranceValidation,
        ...values,
      },
    });

    setShowCommunications(true);
  };

  if (showCommunications) {
    return (
      <CommunicationsCMD
        setShowAccountData={setShowAccountData}
        setShowCommunications={setShowCommunications}
      />
    );
  }

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container">
        <Row className="register-header-row">
          {!(
            isLoading ||
            isLoadingAttributes ||
            isStartingRegister ||
            (!isMultiLanguage && !isStartRegisterCompleted) ||
            (isMultiLanguage && isLanguageSelected && !isStartRegisterCompleted)
          ) && (
            <Header1
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="register-welcome-header">
              {isMultiLanguage && !isLanguageSelected
                ? labels?.registoCMD_multi_language_pageTitle
                : showAccountData
                  ? labels?.registoCMD_registerScreenTitle
                  : labels?.registoCMD_before_continue_cmd_title}
            </Header1>
          )}
        </Row>

        {isLoading ||
        isLoadingAttributes ||
        isStartingRegister ||
        (!isMultiLanguage && !isStartRegisterCompleted) ||
        (isMultiLanguage && isLanguageSelected && !isStartRegisterCompleted) ? (
          <AppSpinner
            type="grey"
            style={{
              width: 'fit-content',
              justifyContent: 'center',
              alignSelf: 'center',
            }}></AppSpinner>
        ) : (
          <>
            {isMultiLanguage && !isLanguageSelected ? (
              renderLanguageSelector()
            ) : showAccountData ? (
              <AccountDataCMD language={currentLanguage} />
            ) : (
              <BeforeContinueCMD
                onSubmit={beforeContinueOnSubmit}
                submitting={submitting}
              />
            )}
          </>
        )}
      </Column>
    </Column>
  );
};

const mapStateToProps = ({
  wizard,
  strings,
  globalStyles,
  stringsDefault,
  user,
  language,
  isLanguageSelected,
  languageOptions,
  tenant,
}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.registoCMD,
  labelsRegister: stringsDefault.value.pt.register,
  labelsMessages: stringsDefault.value.pt.messages,
  globalStyles: globalStyles.value,
  reduxStrings: stringsDefault.value,
  user: user.value,
  language: language.value,
  isLanguageSelected: isLanguageSelected.value,
  languageOptions: languageOptions.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setStrings: (value: any) => dispatch(setStrings(value)),
  setStringsDefault: (value: any) => dispatch(setStringsDefault(value)),
  setBuDefaultFunctionalities: (value: any) =>
    dispatch(setBuDefaultFunctionalities(value)),
  setIsLanguageSelected: (value: any) => dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
  setLanguageOptions: (value: any) => dispatch(setLanguageOptions(value)),
});

export default compose(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterPageCMD)),
);
